var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog207(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_207"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_207",
    "data-name": 207,
    className: "cls-2",
    d: "M12.75,11.53C3.31,25.58,19,49.22,27,61.33c6.27,9.42,25.76,38.76,46.52,35.76,9.7-1.4,20.39-7.28,18.19-18.61a33.7,33.7,0,0,0-4.22-10A481.9,481.9,0,0,0,54.44,18.41C49.61,11.92,43.93,3.21,35.08,2.32,27,1.5,17.31,4.76,12.75,11.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog207);
export default __webpack_public_path__ + "static/media/dog_207.c47475142673f49475826d7955ec594f.svg";
export { ForwardRef as ReactComponent };